module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"handleWom.newInboxMessage.widget":[{"value":"#newMessageCount","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}],"handleWom.newInboxMessage.event":[{"value":"newInboxMessage","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}],"handleWom.newInboxMessage.callback":[{"value":function (data) {
var dsn = this.wom1('#desktopNotifications');
var title = ['New message from', fox.getEnv('screenName')].join(' ');
if (!fox.isEmpty(fox.objectGet(data, 'data.attachments.collection'))) {
title = ['New message with private content from', fox.getEnv('screenName')].join(' ');
};
dsn.push(title, {
body: data.message,
icon: fox.getEnv('socialImage'),
notifyClick: function(){
fox.site.gotoPage('conversation');
}
}, true);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/messageRecieveHandler.js
// module id = 671
// module chunks = 4